import service from '../request/index'

// 我的消息列表
export function messageList (data) {
  return service({
    url: '/es/resource/my/messageList',
    method: 'GET',
    params:data
  })
}

// 我的消息-详情
export function messageDetail (data) {
  return service({
    url: '/es/resource/my/messageDetail',
    method: 'GET',
    params:data
  })
}

// 全部已读
export function messageReadAll () {
  return service({
    url: '/es/resource/my/messageReadAll',
    method: 'GET',
  })
}

// 我的消息-已读一条
export function messageRead (data) {
  return service({
    url: '/es/resource/my/messageRead',
    method: 'GET',
    params:data
  })
}

// 我的消息-未读消息总数
export function unreadMessageCount (data) {
  return service({
    url: '/es/resource/my/unreadMessageCount',
    method: 'GET',
  })
}